import { CHANGEEXPENSE_SUCCESS, CHANGEEXPENSE_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const changeExpenseReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGEEXPENSE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case CHANGEEXPENSE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default changeExpenseReducer;
